"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const translation_hooks_1 = require("@hooks/translation.hooks");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
require("./styles.scss");
const Footer = () => {
    const translator = (0, translation_hooks_1.useComponentTranslation)("footer");
    return (react_1.default.createElement("div", { className: "c-footer" },
        react_1.default.createElement("div", { className: "c-footer__copyright" }, translator("copyright", { year: new Date().getFullYear() })),
        react_1.default.createElement("div", { className: "c-footer__links" },
            react_1.default.createElement(react_router_dom_1.Link, { className: "c-footer__link g-link", to: "/terms", target: "_blank" }, translator("privacyLinkLabel")),
            react_1.default.createElement(react_router_dom_1.Link, { className: " c-footer__link g-link", to: "/policy", target: "_blank" }, translator("termsLinkLabel")))));
};
exports.Footer = Footer;
